import { render, staticRenderFns } from "./MidRiskScoreForAtrialFibrillation.vue?vue&type=template&id=4a200ed4&scoped=true&"
import script from "./MidRiskScoreForAtrialFibrillation.vue?vue&type=script&lang=js&"
export * from "./MidRiskScoreForAtrialFibrillation.vue?vue&type=script&lang=js&"
import style0 from "./MidRiskScoreForAtrialFibrillation.vue?vue&type=style&index=0&id=4a200ed4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a200ed4",
  null
  
)

export default component.exports